import React, { memo, useEffect, useState } from "react";
import {
  Drawer,
  Row,
  Col,
  Space,
  Typography,
  Card,
  Table,
  Empty,
  theme,
  Select,
} from "antd";
import scalesConfig from "../../../../helpers/physioscaleskeys";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import ScaleTable from "./progressTable";
import ProgressChart from "./progressChart";
import ProgressChartOp from "../../../OpEMR/Physiotherapist/ProgressScalesOP/progressChartOp";
import tableIcon from "../../../../assets/images/table.svg";
import tableIconActive from "../../../../assets/images/activetable.svg";
import chartIcon from "../../../../assets/images/bar-chart-2.svg";
import chartIconActive from "../../../../assets/images/active-bar-chart-2.svg";
import "../../../OpEMR/Physiotherapist/ProgressScalesOP/progressScalesOp.css";
import "./progressScales.css";

const gcsTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Score", dataIndex: "score", key: "score" },
  {
    title: "Interpretation",
    dataIndex: "interpretation",
    key: "interpretation",
  },
  {
    title: "Eye Opening (E)",
    dataIndex: "eye_opening_response",
    key: "eye_opening_response",
  },
  { title: "Verbal (V)", dataIndex: "verbal_response", key: "verbal_response" },
  { title: "Motor (M)", dataIndex: "motor_response", key: "motor_response" },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];

const romTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Joint", dataIndex: "joint", key: "joint" },
  { title: "Movement", dataIndex: "movement", key: "movement" },
  { title: "Side", dataIndex: "side", key: "side" },
  { title: "Type", dataIndex: "type", key: "type" },
  { title: "Value (°)", dataIndex: "value", key: "value" },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];

const tctTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  {
    title: "Sitting Balance",
    dataIndex: "sitting_balance",
    key: "sitting_balance",
  },
  {
    title: "Selective Movement Control",
    dataIndex: "selective_movement_control",
    key: "selective_movement_control",
  },
  {
    title: "Sitting to Standing",
    dataIndex: "sitting_to_standing",
    key: "sitting_to_standing",
  },
  { title: "Score", dataIndex: "score", key: "score" },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];

const rassTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "RASS Score", dataIndex: "rass_scale", key: "rass_scale" },
  {
    title: "Interpretation",
    dataIndex: "interpretation",
    key: "interpretation",
  },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];

const mocaTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Score", dataIndex: "score", key: "score" },
  {
    title: "Interpretation",
    dataIndex: "interpretation",
    key: "interpretation",
  },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];

const nihssTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Score", dataIndex: "score", key: "score" },
  {
    title: "Interpretation",
    dataIndex: "interpretation",
    key: "interpretation",
  },
];

const vasTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Pain", dataIndex: "pain", key: "pain" },
  // { title: "Score", dataIndex: "score", key: "score" },
  {
    title: "Interpretation",
    dataIndex: "interpretation",
    key: "interpretation",
  },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];

const rpeTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Exertion", dataIndex: "exertion", key: "exertion" },
  // { title: "Score", dataIndex: "score", key: "score" },
  {
    title: "Interpretation",
    dataIndex: "interpretation",
    key: "interpretation",
  },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];

const biTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Score", dataIndex: "score", key: "score" },
  {
    title: "Interpretation",
    dataIndex: "interpretation",
    key: "interpretation",
  },
];
const gripStrengthTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Age", dataIndex: "age", key: "age" },
  { title: "Left Hand (kg)", dataIndex: "left_hand", key: "left_hand" },
  { title: "Right Hand (kg)", dataIndex: "right_hand", key: "right_hand" },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];
const asiaTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  {
    title: "Neurological Level of Injury",
    dataIndex: "nerological_level_of_injury",
    key: "nerological_level_of_injury",
  },
  {
    title: "ASIA Impairment Scale",
    dataIndex: "asia_impairment_scale",
    key: "asia_impairment_scale",
  },
];
const peakFlowMeterTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Gender", dataIndex: "gender", key: "gender" },
  { title: "Age", dataIndex: "age", key: "age" },
  { title: "Height (cm)", dataIndex: "height", key: "height" },
  {
    title: "Predicted PEFR",
    dataIndex: "predicted_PEFR",
    key: "predicted_PEFR",
  },
  { title: "Test PEFR", dataIndex: "test_PEFR", key: "test_PEFR" },
  {
    title: "Comments",
    dataIndex: "comments",
    key: "comments",
    render: (text) => text || "N/A",
  },
];
const sixMinuteWalkTableColumns = [
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "HR (Pre)", dataIndex: "heart_rate", key: "heart_rate" },
  {
    title: "HR (Post)",
    dataIndex: "post_vital_heart_rate",
    key: "post_vital_heart_rate",
  },

  { title: "SBP (Pre)", dataIndex: "sbp", key: "sbp" },
  { title: "SBP (Post)", dataIndex: "post_vital_sbp", key: "post_vital_sbp" },

  { title: "DBP (Pre)", dataIndex: "dbp", key: "dbp" },
  { title: "DBP (Post)", dataIndex: "post_vital_dbp", key: "post_vital_dbp" },

  { title: "SpO₂ (Pre)", dataIndex: "spo2", key: "spo2" },
  {
    title: "SpO₂ (Post)",
    dataIndex: "post_vital_spo2",
    key: "post_vital_spo2",
  },

  { title: "RR (Pre)", dataIndex: "rr", key: "rr" },
  { title: "RR (Post)", dataIndex: "post_vital_rr", key: "post_vital_rr" },

  { title: "RPE (Pre)", dataIndex: "rpe", key: "rpe" },
  { title: "RPE (Post)", dataIndex: "post_vital_rpe", key: "post_vital_rpe" },

  { title: "No. of Laps", dataIndex: "no_of_laps", key: "no_of_laps" },
  {
    title: "Distance (m)",
    dataIndex: "distance_covered",
    key: "distance_covered",
  },
];

const asiaGradeMap = { A: 1, B: 2, C: 3, D: 4, E: 5 };
const convertAsiaGrade = (value) => {
  if (!value) return null;
  return asiaGradeMap[String(value).toUpperCase()] ?? null;
};

const convertNeurologicalLevel = (level) => {
  if (!level) return null;
  const match = String(level)
    .toUpperCase()
    .match(/([A-Z])(\d+)/);
  if (!match) return null;

  const region = match[1];
  const num = parseInt(match[2], 10);
  const offsets = { C: 0, T: 8, L: 20, S: 25 };

  return offsets[region] !== undefined ? offsets[region] + num : null;
};

const getScaleData = (scaleKey, data, subItemKey) => {
  const scale = scalesConfig[scaleKey];
  if (!data || !scale) return [];
  const keysConfig = subItemKey
    ? scalesConfig[scaleKey]?.subItems?.[subItemKey]?.keys
    : scale?.keys;

  return data.map((item) => {
    const formattedDate = item?.date
      ? new Date(item.date).toLocaleString("en-US", {
          day: "2-digit",
          month: "short",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "Unknown Date";

    const chartEntry = {
      name: formattedDate,
      _ts: item?.date ? new Date(item.date).getTime() : undefined,
    };
    Object.entries(keysConfig || {}).forEach(([key]) => {
      if (item[key] === undefined) return;

      if (scaleKey === "ASIA") {
        if (key === "nerological_level_of_injury") {
          chartEntry[key] = convertNeurologicalLevel(item[key]);
          chartEntry._nli_label = item[key];
          return;
        }
        if (key === "asia_impairment_scale") {
          chartEntry[key] = convertAsiaGrade(item[key]);
          chartEntry._asia_grade_label = item[key];
          return;
        }
      }

      chartEntry[key] = item[key];
    });
    if (item.score !== undefined) chartEntry.score = item.score;
    return chartEntry;
  });
};

const getRomTableData = (dataArray) => {
  if (!dataArray || !dataArray.length) return [];

  const tablesMap = {};
  const ROM_JOINT_KEYS = new Set([
    "shoulder_joint",
    "elbow_joint",
    "forearm_joint",
    "wrist_joint",
    "thumb_joint",
    "metacarpel_joint",
    "proximal_joint",
    "disital_joint",
    "hip_joint",
    "knee_joint",
    "ankle_joint",
    "foot_joint",
    "great_toe_joint",
    "inter_phalangeal_joint",
    "cervical_spine",
    "thoraco_lumbar_spine",
  ]);

  dataArray.forEach((entry) => {
    Object.keys(entry).forEach((key) => {
      if (key === "date" || typeof entry[key] !== "object") return;
      if (!ROM_JOINT_KEYS.has(key)) return;

      if (!tablesMap[key]) tablesMap[key] = [];
      const formattedDate = entry.date
        ? new Date(entry.date).toLocaleString("en-US", {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : "Unknown Date";

      const jointEntry = { id: entry.id, date: formattedDate, ...entry[key] };
      tablesMap[key].push(jointEntry);
    });
  });

  return Object.keys(tablesMap).map((jointKey) => {
    const jointData = tablesMap[jointKey];
    const allKeys = Array.from(
      jointData.reduce((set, row) => {
        Object.keys(row || {}).forEach((k) => set.add(k));
        return set;
      }, new Set())
    ).filter((k) => !["date", "id", "key"].includes(k));

    const columns = [
      { title: "Date", dataIndex: "date", key: "date", width: 140 },
      ...allKeys.map((k) => ({
        title: k.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
        dataIndex: k,
        key: k,
        width: 120,
      })),
    ];
    return {
      jointName: jointKey
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase()),
      dataSource: jointData,
      columns,
    };
  });
};

const getSimpleTableData = (data) =>
  (data || []).map((entry, idx) => ({
    key: entry.id || idx,
    ...entry,
    date: entry.date
      ? new Date(entry.date).toLocaleString("en-US", {
          day: "2-digit",
          month: "short",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "Unknown Date",
  }));

const ScaleModal = memo(
  ({ patientData, scaleKey, data, isVisible, onClose }) => {
    const [viewMode, setViewMode] = useState("table");
    const [isMobileViewport, setIsMobileViewport] = useState(false);
    const [romMobileJointKey, setRomMobileJointKey] = useState(null);
    const { token } = theme.useToken();
    const scaleType = scalesConfig[scaleKey]?.type;
    const showToggle = [
      "GCS",
      "ROM",
      "TrunkControlTest",
      "RASS",
      "MOCA",
      "NIHSS",
      "VAS",
      "RPE",
      "BarthelIndex",
      "FingerGripTest",
      "ASIA",
      "PeakFlowMeterTest",
      "SixMinuteWalkTest",
    ].includes(scaleKey);
    const formattedChartData = React.useMemo(
      () => getScaleData(scaleKey, data),
      [scaleKey, data]
    );
    const romTables = React.useMemo(
      () => (scaleKey === "ROM" ? getRomTableData(data) : []),
      [scaleKey, data]
    );

    useEffect(() => {
      const mq = window.matchMedia("(max-width: 768px)");
      const onChange = () => setIsMobileViewport(mq.matches);
      onChange();
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }, []);

    const romSubItems = scalesConfig[scaleKey]?.subItems || {};
    const romJointKeys = Object.keys(romSubItems);
    const romSelectedJoint =
      romMobileJointKey && romSubItems[romMobileJointKey]
        ? romMobileJointKey
        : romJointKeys[0];
    const selectedRomTable = romTables.find(
      (joint) =>
        joint.jointName?.toLowerCase() ===
        (
          romSubItems?.[romSelectedJoint]?.name ||
          romSelectedJoint?.replace(/_/g, " ")
        )?.toLowerCase()
    );
    const selectedRomChartData = getScaleData(
      scaleKey,
      (data || [])
        .map((entry) => ({
          ...(entry?.[romSelectedJoint] || {}),
          date: entry?.date,
        }))
        .filter((entry) => entry.date),
      romSelectedJoint
    );

    const getTableColumns = () => {
      switch (scaleKey) {
        case "GCS":
          return gcsTableColumns;
        case "ROM":
          return romTableColumns;
        case "TrunkControlTest":
          return tctTableColumns;
        case "RASS":
          return rassTableColumns;
        case "MOCA":
          return mocaTableColumns;
        case "NIHSS":
          return nihssTableColumns;
        case "VAS":
          return vasTableColumns;
        case "RPE":
          return rpeTableColumns;
        case "BarthelIndex":
          return biTableColumns;
        case "FingerGripTest":
          return gripStrengthTableColumns;
        case "ASIA":
          return asiaTableColumns;
        case "PeakFlowMeterTest":
          return peakFlowMeterTableColumns;
        case "SixMinuteWalkTest":
          return sixMinuteWalkTableColumns;
        default:
          return [];
      }
    };

    return (
      <Drawer
        visible={isVisible}
        closable={false}
        width="100vw"
        placement="right"
        className="ip-progress-scale-modal scale-modal-drawer"
        bodyStyle={{
          backgroundColor: "#F3F5F8",
          height: "100vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          padding: 0,
        }}
        title={
          <Row className="scale-mobile-header">
            <Col flex="auto" className="scale-header-primary">
              <div className="scale-header-primary-inner">
                <Space>
                  <LeftOutlined
                    onClick={onClose}
                    className="scale-modal-nav-icon"
                  />
                  <Typography className="patient-name">
                    {`${patientData?.patient?.first_name || ""} ${
                      patientData?.patient?.last_name || ""
                    }`.trim()}
                  </Typography>
                </Space>
                {showToggle && (
                  <div className="scale-header-mobile-toggles">
                    <div
                      className="mobile-toggle-btn"
                      onClick={() => setViewMode("table")}
                      style={{
                        background:
                          viewMode === "table" ? token.colorPrimary : "#fff",
                        borderColor:
                          viewMode === "table" ? token.colorPrimary : "#d0d5dd",
                      }}
                    >
                      <img
                        src={viewMode === "table" ? tableIconActive : tableIcon}
                        alt=""
                      />
                    </div>
                    <div
                      className="mobile-toggle-btn"
                      onClick={() => setViewMode("graph")}
                      style={{
                        background:
                          viewMode === "graph" ? token.colorPrimary : "#fff",
                        borderColor:
                          viewMode === "graph" ? token.colorPrimary : "#d0d5dd",
                      }}
                    >
                      <img
                        src={viewMode === "graph" ? chartIconActive : chartIcon}
                        alt=""
                      />
                    </div>
                  </div>
                )}
              </div>
            </Col>
            <Col className="header-sub">
              <Typography className="scale-modal-subtitle">
                {scalesConfig[scaleKey]?.expandedName || scaleKey}
              </Typography>
            </Col>
            <Col className="header-actions scale-header-actions-desktop">
              <Space align="center">
                {showToggle && (
                  <div className="desktop-toggle">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        background: token.colorPrimaryBg,
                        borderRadius: "10px",
                        padding: "4px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        width: "90px",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        onClick={() => setViewMode("table")}
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "center",
                          background:
                            viewMode === "table"
                              ? token.colorPrimary
                              : "transparent",
                          borderRadius: "10px",
                          padding: "8px 0",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={
                            viewMode === "table" ? tableIconActive : tableIcon
                          }
                          width={20}
                          alt=""
                        />
                      </div>
                      <div
                        onClick={() => setViewMode("graph")}
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "center",
                          background:
                            viewMode === "graph"
                              ? token.colorPrimary
                              : "transparent",
                          borderRadius: "10px",
                          padding: "8px 0",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={
                            viewMode === "graph" ? chartIconActive : chartIcon
                          }
                          width={20}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                )}
                <CloseOutlined
                  onClick={onClose}
                  className="scale-modal-close-icon"
                />
              </Space>
            </Col>
          </Row>
        }
      >
        <div className="ip-scale-drawer-content">
        <Row
          gutter={[16, 16]}
          style={{
            margin: 0,
            width: "100%",
            maxWidth: "100%",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {scaleType === "table" ? (
            <Row justify="center" style={{ width: "100%" }}>
              <Col span={24}>
                <ScaleTable scaleKey={scaleKey} data={data} />
              </Col>
            </Row>
          ) : scaleKey === "ROM" ? (
            viewMode === "graph" ? (
              isMobileViewport ? (
                <Col span={24}>
                  <div className="ip-rom-mobile-view">
                    <Select
                      className="ip-rom-mobile-select"
                      value={romSelectedJoint}
                      onChange={setRomMobileJointKey}
                      options={romJointKeys.map((key) => ({
                        value: key,
                        label:
                          romSubItems?.[key]?.name || key.replace(/_/g, " "),
                      }))}
                    />
                    <Card className="ip-progress-graph-card">
                      <ProgressChartOp
                        scaleKey={scaleKey}
                        tags={Object.keys(
                          romSubItems?.[romSelectedJoint]?.keys || {}
                        )}
                        chartData={selectedRomChartData}
                        subItemKey={romSelectedJoint}
                        height={330}
                        useMobileMetricDropdown
                      />
                    </Card>
                  </div>
                </Col>
              ) : Object.entries(scalesConfig[scaleKey]?.subItems || {}).map(
                ([subItemKey, subItemValue]) => {
                  const subItemData = data
                    .map((entry) => ({
                      ...entry[subItemKey],
                      date: entry.date,
                    }))
                    .filter((entry) => entry.date);
                  return (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={12}
                      xl={12}
                      key={subItemKey}
                      style={{ display: "flex" }}
                    >
                      <Card
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Space size="large" direction="vertical">
                          {scalesConfig[scaleKey]?.subItems[subItemKey]?.name}
                          <ProgressChart
                            scaleKey={scaleKey}
                            tags={Object.keys(subItemValue?.keys || {})}
                            chartData={getScaleData(
                              scaleKey,
                              subItemData,
                              subItemKey
                            )}
                            subItemKey={subItemKey}
                            height={300}
                          />
                        </Space>
                      </Card>
                    </Col>
                  );
                }
              )
            ) : (
              <Col span={24}>
                {isMobileViewport ? (
                  <div className="ip-rom-mobile-view">
                    <Select
                      className="ip-rom-mobile-select"
                      value={romSelectedJoint}
                      onChange={setRomMobileJointKey}
                      options={romJointKeys.map((key) => ({
                        value: key,
                        label:
                          romSubItems?.[key]?.name || key.replace(/_/g, " "),
                      }))}
                    />
                    {!selectedRomTable ? (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No data"
                      />
                    ) : (
                      <Table
                        dataSource={selectedRomTable.dataSource}
                        columns={selectedRomTable.columns}
                        pagination={false}
                        bordered
                        scroll={{ x: "max-content" }}
                      />
                    )}
                  </div>
                ) : romTables.length === 0 ? (
                  <Card style={{ width: "100%" }}>
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="No data"
                    />
                  </Card>
                ) : (
                  romTables.map((joint, index) => (
                    <Card
                      key={index}
                      title={joint.jointName}
                      style={{ marginBottom: 16 }}
                      bodyStyle={{ padding: 0 }}
                    >
                      <Table
                        dataSource={joint.dataSource}
                        columns={joint.columns}
                        pagination={false}
                        bordered
                        scroll={{ x: "max-content" }}
                        locale={{ emptyText: "No data" }}
                      />
                    </Card>
                  ))
                )}
              </Col>
            )
          ) : showToggle ? (
            viewMode === "graph" ? (
              <Card className="ip-progress-graph-card" style={{ width: "100%" }}>
                {isMobileViewport ? (
                  <ProgressChartOp
                    scaleKey={scaleKey}
                    tags={Object.keys(scalesConfig[scaleKey]?.keys || {})}
                    chartData={formattedChartData}
                    height={330}
                  />
                ) : (
                  <ProgressChart
                    scaleKey={scaleKey}
                    tags={Object.keys(scalesConfig[scaleKey]?.keys || {})}
                    chartData={formattedChartData}
                    height={550}
                  />
                )}
              </Card>
            ) : (
              <Col span={24}>
                <Table
                  columns={getTableColumns()}
                  dataSource={getSimpleTableData(data)}
                  pagination={{ pageSize: 10 }}
                  rowKey={(record) => record.key}
                  scroll={{ x: "max-content" }}
                />
              </Col>
            )
          ) : (
            <Card style={{ width: "100%" }}>
              <ProgressChart
                scaleKey={scaleKey}
                tags={Object.keys(scalesConfig[scaleKey]?.keys || {})}
                chartData={getScaleData(scaleKey, data)}
                height={550}
              />
            </Card>
          )}
        </Row>
        </div>
      </Drawer>
    );
  }
);

export default ScaleModal;
